export const environment = {
  production: true,
  mailServiceUrl: 'https://emailservice.christopheboulain.fr/api/emails',
  mailContact: 'Christophe.Boulain@gmail.com'
};
